export default __webpack_public_path__ + "static/media/Operations_Delivery_Manager_Role.2c11f242.svg";